import { render, staticRenderFns } from "./ping_labels.vue?vue&type=template&id=214d1a34&scoped=true&"
import script from "./ping_labels.vue?vue&type=script&lang=ts&"
export * from "./ping_labels.vue?vue&type=script&lang=ts&"
import style0 from "./ping_labels.vue?vue&type=style&index=0&id=214d1a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d1a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
